import api from '../../api';

const resendUnusualAccessEmail = payload => {
  return api.post('/traders/resendUnusualAccessEmail', payload);
};

export default resendUnusualAccessEmail;
